import {
    FETCH_MONITOR,
    LIST_MONITOR, UPDATE_MONITOR
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: {},
    page: 1,
    size: 10,
    totals: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MONITOR:
            return {
                ...state,
                ...init,
                isLoading: true,
                filter: payload
            };
        case LIST_MONITOR:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        case UPDATE_MONITOR:
            // Check drawCode exists
            if (!payload.drawCode) return state;

            // If drawCode is different, reset the state
            if (state.list.drawCode !== payload.drawCode) {
                return {
                    ...state,
                    list: {
                        ...payload,  // Replace state with new draw data
                        items: payload.items.map(bet => ({
                            betCode: bet.betCode.toLowerCase(), // Ensure case matching
                            total: bet.betAmount,
                            items: [bet]  // Start fresh with new bet
                        }))
                    }
                };
            }

            // If drawCode matches, update bets in real-time
            const updatedItems = state.list.items.map(category => {
                const newBets = payload.items.filter(
                    bet => bet.betCode.toLowerCase() === category.betCode
                );

                return {
                    ...category,
                    items: [...newBets, ...category.items], // Append new bets
                    total: category.total + newBets.reduce((sum, bet) => sum + bet.betAmount, 0)
                };
            });

            return {
                ...state,
                list: {
                    ...state.list,
                    items: updatedItems
                }
            };

        default:
            return state;
    }
}